<!--
 * @Description: 资源覆盖时效
 * @Author: luohuan
 * @Date: 2025-08-20 16:38:03
 * @LastEditTime: 2025-08-20 16:38:03
 * @LastEditors: luohuan
-->
<template>
  <el-dialog
    v-dialogDrag
    :title="title"
    :visible.sync="visible"
    width="500px"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    append-to-body
    :element-loading-background="loadingBackground"
    custom-class="add-concat-dialog"
    v-loading="loading"
    @open="openDialog"
  >
    <el-form
      ref="addForm"
      label-width="135px"
      :model="addForm"
      :rules="formRules"
      :inline="true"
    >
      <el-form-item prop="provinceId" label="省份:" v-if="addType != 4">
        <e6-vr-select
          v-model="addForm.provinceId"
          :data="provinceList"
          placeholder="省"
          title="省"
          clearable
          virtual
          :is-title="true"
          :props="{
            id: 'code',
            label: 'name'
          }"
        ></e6-vr-select>
      </el-form-item>
      <el-form-item prop="cityId" label="城市:" v-if="addType != 4">
        <e6-vr-select
          v-model="addForm.cityId"
          :data="cityNameList"
          placeholder="市"
          title="市"
          clearable
          virtual
          :is-title="true"
          :props="{
            id: 'code',
            label: 'name'
          }"
        ></e6-vr-select>
      </el-form-item>
      <el-form-item prop="countyId" label="区县:" v-if="addType != 4">
        <e6-vr-select
          v-model="addForm.countyId"
          :data="districtList"
          placeholder="区"
          title="区"
          clearable
          virtual
          :is-title="true"
          :props="{
            id: 'code',
            label: 'name'
          }"
        ></e6-vr-select>
      </el-form-item>

      <el-form-item prop="timeLimitType" label="上门时效:">
        <e6-vr-select
          v-model="addForm.timeLimitType"
          :data="timeLimitTypes"
          placeholder="上门时效"
          title="上门时效"
          clearable
          :props="{
            id: 'codeValue',
            label: 'codeName'
          }"
        ></e6-vr-select>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer" v-if="addType != 3">
      <el-button class="cancel" @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import base from "@/mixins/base";
import {
  findDownList,
  getProviceList,
  addAreaTimeLimit,
  updateAreaTimeLimit,
  batchUpdateAreaTimeLimit
} from "@/api";
import { printError } from "@/utils/util";
export default {
  name: "addAreaTimeLimit",
  components: {},
  data() {
    return {
      loading: false,
      initialized: false,
      provinceList: [],
      cityNameList: [],
      districtList: [],
      timeLimitTypes: [],

      addForm: {
        provinceId: "",
        provinceName: "",

        cityId: "",
        cityName: "",
        countyId: "",
        countyName: "",
        timeLimitType: "",
        timeLimitId: null
      },
      addFormRules: {
        provinceId: [
          {
            required: true,
            message: "请选择省份",
            trigger: ["blur", "change"]
          }
        ],
        timeLimitType: [
          {
            required: true,
            message: "请选择时效",
            trigger: ["blur", "change"]
          }
        ]
      },

      batchUpdateFormRules: {
        provinceId: [
          {
            required: true,
            message: "请选择省份",
            trigger: ["blur", "change"]
          }
        ],
        timeLimitType: [
          {
            required: true,
            message: "请选择时效",
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  props: {
    addVisible: {
      type: Boolean,
      default: false
    },
    //1新增2编辑3详情
    addType: {
      type: [Number, String],
      default: 1
    },
    clickRow: {
      type: Object,
      default: () => {}
    },
    serviceIdList: {
      type: Array,
      default: () => []
    }
  },
  mixins: [base],
  computed: {
    formRules() {
      if (this.addType == 1 || this.addType == 2) {
        return this.addFormRules;
      } else if (this.addType == 3) {
        return this.batchUpdateFormRules;
      } else {
        return {};
      }
    },
    visible: {
      get() {
        return this.addVisible;
      },
      set(val) {
        this.$emit("update:addVisible", val);
      }
    },
    title() {
      let res;
      switch (this.addType) {
        case 1:
          res = "新增资源覆盖时效";
          break;
        case 2:
          res = "编辑资源覆盖时效";
          break;
        case 3:
          res = "资源覆盖时效详情";
          break;
        case 4:
          res = "批量编辑资源覆盖时效";
          break;

        default:
          res = "";
          break;
      }

      return res;
    }
  },
  watch: {
    "addForm.provinceId": {
      immediate: true,
      handler(val) {
        if (!this.initialized) {
          return;
        }
        if (val) {
          this.addForm.cityId = "";
          this.addForm.countyId = "";
          this.addForm.cityName = "";
          this.addForm.countyName = "";

          this.districtList = [];

          // 查找选中的省份对象
          const selectedProvince = this.provinceList.find(
            item => item.code === val
          );
          // 更新省份名称
          this.addForm.provinceName = selectedProvince
            ? selectedProvince.name
            : "";

          // 改为调用同步方法
          this.loadCityList(val);
        } else {
          this.addForm.provinceName = "";
        }
      }
    },
    "addForm.cityId": {
      immediate: true,
      handler(val) {
        if (!this.initialized) {
          return;
        }
        if (val) {
          // 查找选中的省份对象
          const selectedCity = this.cityNameList.find(
            item => item.code === val
          );
          // 更新省份名称
          this.addForm.cityName = selectedCity ? selectedCity.name : "";

          // 改为调用同步方法
          this.loadDistrictList(val);

          this.addForm.countyId = "";
          this.addForm.countyName = "";
        } else {
          this.addForm.cityName = "";
        }
      }
    },
    "addForm.countyId": {
      immediate: true,
      handler(val) {
        if (!this.initialized) {
          return;
        }
        if (val) {
          // 查找选中的省份对象
          const selectedCounty = this.districtList.find(
            item => item.code === val
          );
          // 更新省份名称
          this.addForm.countyName = selectedCounty ? selectedCounty.name : "";
        } else {
          this.addForm.countyName = "";
        }
      }
    }
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      try {
        this.loading = true;
        //  let promiseList = [
        //  findDownList(["areaTimeLimitType"])
        // ];
        //let [enumRes] = await Promise.all(promiseList);

        //上门时效
        //this.timeLimitTypes = this.getFreezeResponse(enumRes, {
        //path: "data.areaTimeLimitType"
        // });
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //打开
    openDialog() {
      // 先禁用watch
      this.initialized = false;

      if (this.addType != 1) {
        let clickRow = _.cloneDeep(this.clickRow);

        // 使用回调方式加载数据
        this.loadAreaTimeLimitTypeList(() => {
          if (this.addType == 4  ) {
            // this.addForm.timeLimitType = "";
          }else{
            this.addForm.timeLimitType = this.clickRow.timeLimitType.toString();
          }
        });

        this.loadProvinceList();

        if (this.clickRow.provinceId) {
          this.loadCityList(this.clickRow.provinceId);
        }

        if (this.clickRow.cityId) {
          this.loadDistrictList(this.clickRow.cityId);
        }
        this.addForm.provinceId = clickRow.provinceId;
        this.addForm.cityId = clickRow.cityId;
        this.addForm.countyId = clickRow.countyId;
        // this.addForm.timeLimitType = clickRow.timeLimitType;
        this.addForm.timeLimitId = clickRow.timeLimitId;
        this.addForm.provinceName = clickRow.provinceName;
        this.addForm.cityName = clickRow.cityName;
        this.addForm.countyName = clickRow.countyName;
      } else {
        this.loadAreaTimeLimitTypeList();
        this.loadProvinceList();
      }

      this.$nextTick(() => {
        this.initialized = true;
        this.$refs.addForm.clearValidate();
      });
    },

    // 同步方法，但内部仍然调用异步请求
    loadProvinceList() {
      getProviceList({ type: "-65536", code: "" })
        .then(res => {
          // 初始化省份列表
          this.provinceList = res.data;
        })
        .catch(error => {
          printError(error);
        });
    },

    loadAreaTimeLimitTypeList(callback) {
      findDownList(["areaTimeLimitType"])
        .then(res => {
          //上门时效
          this.timeLimitTypes = res.data.areaTimeLimitType;

          // 执行回调函数
          if (callback && typeof callback === "function") {
            callback();
          }
        })
        .catch(error => {
          printError(error);
        });
    },

    // 同步方法，但内部仍然调用异步请求
    loadCityList(provinceCode) {
      getProviceList({ type: "-256", code: provinceCode })
        .then(res => {
          this.cityNameList = res.data;
        })
        .catch(error => {
          printError(error);
        });
    },

    // 同步方法，但内部仍然调用异步请求
    loadDistrictList(cityCode) {
      getProviceList({ type: "-1", code: cityCode })
        .then(res => {
          this.districtList = res.data;
        })
        .catch(error => {
          printError(error);
        });
    },
    //点击确定
    confirm() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (this.addType == 1) {
            this.addAreaTimeLimitReq();
          } else if (this.addType == 2) {
            //编辑
            this.updateAreaTimeLimitReq();
          } else if (this.addType == 4) {
            //批量编辑
            this.batchUpdateServiceProviderReq();
          }
        }
      });
    },
    //新增
    async addAreaTimeLimitReq() {
      try {
        this.loading = true;
        let res = await addAreaTimeLimit({
          ...this.addForm
        });
        if (res.code == "OK") {
          this.$message.success("新增成功");
          this.$emit("refreshList");
          this.closeDialog();
        }
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //编辑
    async updateAreaTimeLimitReq() {
      try {
        this.loading = true;
        let res = await updateAreaTimeLimit({
          ...this.addForm
        });
        if (res.code == "OK") {
          this.$message.success("编辑成功");
          this.$emit("refreshList");
          this.closeDialog();
        }
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //批量编辑
    async batchUpdateServiceProviderReq() {
      try {
        this.loading = true;
        let res = await batchUpdateAreaTimeLimit({
          timeLimitIdList: this.serviceIdList,
          timeLimitType: this.addForm.timeLimitType
        });
        if (res.code == "OK") {
          this.$message.success("批量修改成功");
          this.$emit("refreshList");
          this.closeDialog();
        }
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //点击取消
    closeDialog() {
      this.visible = false;
      this.addForm = {
        provinceId: "",
        provinceName: "",

        cityId: "",
        cityName: "",
        countyId: "",
        countyName: "",
        timeLimitType: "",
        timeLimitId: null
      };
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.add-concat-dialog {
  .el-dialog__body {
    padding: 10px;
    box-sizing: border-box;
    overflow-y: auto;
    max-height: 600px;
    .el-input {
      width: 250px;
    }
  }
}
</style>
